import pom from "@/utils/pom";
import { applyDataTestId } from "@/utils/testUtils";
import { useTranslations } from "next-intl";

export interface ModalTextProps {
  subtitleId?: string;
}

export const ModalText = ({ subtitleId }: ModalTextProps) => {
  const t = useTranslations("WelcomeModalText");
  return (
    <div
      data-testid={applyDataTestId(pom.scanToOrder.runningTabsWelcomeModalText)}
      className="px-10 flex flex-col gap-6 text-[#373737]"
      id={subtitleId}
    >
      <p className="text-[15px] text-center">{t("orderingEasy")}</p>
      <div className="flex flex-col items-center justify-center">
        <p>{t("secondCourse")}</p>
        <p>{t("addMoreLater")}</p>
      </div>
    </div>
  );
};
